import React from 'react';
import { useSelector } from 'react-redux';

import { getCurrency } from 'user/userSelectors';
import { getMessage , currencyFormatter } from 'util/locale';
import { inferUnit } from 'util/unitConversion';

const SeedCostRow = ({
  originalCostSeedPerAcre,
  activeCostSeedPerAcre,
  yourPlanCostSeedPerAcre
}: {
  originalCostSeedPerAcre: number;
  activeCostSeedPerAcre: number;
  yourPlanCostSeedPerAcre: number;
}) => {
  const currency = useSelector(getCurrency);

  return (
    <tr>
      <th role='rowheader'>{getMessage('seed-cost-per-area', { areaUnit: inferUnit('area').label.universal })}</th>
      <td>{currencyFormatter(yourPlanCostSeedPerAcre, currency, { round: true })}</td>
      <td>{currencyFormatter(originalCostSeedPerAcre, currency, { round: true })}</td>
      <td>{currencyFormatter(activeCostSeedPerAcre, currency, { round: true })}</td>
    </tr>
  );
};

export default SeedCostRow;
